export const PERM_CODE = {
  URACC: "URACC",
  UREDT: "UREDT",
  URDEL: "URDEL",
  EMACC: "EMACC",
  EMEDT: "EMEDT",
  EMDEL: "EMDEL",
  EMVFY: "EMVFY",
  EMRJT: "EMRJT",
  EMSTS: "EMSTS",
  EMEML: "EMEML",
  EMSQB: "EMSQB",
  ECACC: "ECACC",
  EQACC: "EQACC",
  EQEDT: "EQEDT",
  EQSAP: "EQSAP",
  EQSRJ: "EQSRJ",
  EYACC: "EYACC",
  EYEDT: "EYEDT",
  EYVFY: "EYVFY",
  EYRJT: "EYRJT",
  EYSAC: "EYSAC",
  EPSRJ: "EPSRJ",
  EPEML: "EPEML",
  EAACC: "EAACC",
  EAEDT: "EAEDT",
  EAEML: "EAEML",
  ERACC: "ERACC",
  EREDT: "EREDT",
  ERSRO: "ERSRO",
  BUACC: "BUACC",
  BUEDT: "BUEDT",
  BUVFY: "BUVFY",
  BUSTS: "BUSTS",
  BAACC: "BAACC",
  BAEDT: "BAEDT",
  BAVFY: "BAVFY",
  BASDE: "BASDE",
  BASDL: "BASDL",
  BASBL: "BASBL",
  BDACC: "BDACC",
  BDEDT: "BDEDT",
  BDVFY: "BDVFY",
  BDSRE: "BDSRE",
  BLACC: "BLACC",
  BLEDT: "BLEDT",
  BLVRY: "BLVRY",
  BLSRE: "BLSRE",
  BBACC: "BBACC",
  BBEDT: "BBEDT",
  BBVFY: "BBVFY",
  BIACC: "BIACC",
  BIEDT: "BIEDT",
  IVACC: "IVACC",
  IVEDT: "IVEDT",
  IVVFY: "IVVFY",
  IVSTS: "IVSTS",
  INACC: "INACC",
  IAACC: "IAACC",
  IAEDT: "IAEDT",
  IAVFY: "IAVFY",
  IASDE: "IASDE",
  IDACC: "IDACC",
  IDEDT: "IDEDT",
  IDVFY: "IDVFY",
  IDSAC: "IDSAC",
  IIACC: "IIACC",
  IIEDT: "IIEDT",
  ENACC: "ENACC",
  ENEDT: "ENEDT",
  ENVFY: "ENVFY",
  ENSTS: "ENSTS",
  EEACC: "EEACC",
  EEEDT: "EEEDT",
  EPACC: "EPACC",
  EPEDT: "EPEDT",
  EPVFY: "EPVFY",
  EPSAC: "EPSAC",
  EVACC: "EVACC",
  EVEDT: "EVEDT",
  EVVFY: "EVVFY",
  EVSDE: "EVSDE",
  EVSBL: "EVSBL",
  EDACC: "EDACC",
  EDEDT: "EDEDT",
  EDVFY: "EDVFY",
  EDSRE: "EDSRE",
  EBACC: "EBACC",
  EBEDT: "EBEDT",
  CLACC: "CLACC",
  CLEDT: "CLEDT",
  CLVFY: "CLVFY",
  CLSTS: "CLSTS",
  CAACC: "CAACC",
  CAEDT: "CAEDT",
  CPACC: "CPACC",
  CPEDT: "CPEDT",
  CPVFY: "CPVFY",
  CPSCT: "CPSCT",
  CPSAC: "CPSAC",
  CPSRE: "CPSRE",
  CVACC: "CVACC",
  CVEDT: "CVEDT",
  CVVFY: "CVVFY",
  CVSDE: "CVSDE",
  CVSPE: "CVSPE",
  CDACC: "CDACC",
  CDEDT: "CDEDT",
  CDVFY: "CDVFY",
  CDSRE: "CDSRE",
  CRACC: "CRACC",
  CREDT: "CREDT",
  CRVFY: "CRVFY",
  CRSRO: "CRSRO",
  IUACC: "IUACC",
  IUEDT: "IUEDT",
  IUVFY: "IUVFY",
  DLACC: "DLACC",
  DLVFY: "DLVFY",
  DLEDT: "DLEDT",
  DLSTS: "DLSTS",
  DPACC: "DPACC",
  DPEDT: "DPEDT",
  DPVFY: "DPVFY",
  DPSAP: "DPSAP",
  DPSRE: "DPSRE",
  DMSQB: "DMSQB",
  DAACC: "DAACC",
  DAVFY: "DAVFY",
  DASFU: "DASFU",
  DASCA: "DASCA",
  DASEX: "DASEX",
  DASAG: "DASAG",
  DGACC: "DGACC",
  DGVFY: "DGVFY",
  DGSDI: "DGSDI",
  DGSCA: "DGSCA",
  DGEML: "DGEML",
  DDACC: "DDACC",
  DDEML: "DDEML",
  DEACC: "DEACC",
  DEVFY: "DEVFY",
  DESRE: "DESRE",
  DESCA: "DESCA",
  DESAG: "DESAG",
  DXACC: "DXACC",
  DRACC: "DRACC",
  DREML: "DREML",
  DOACC: "DOACC",
  DOEML: "DOEML",
  DUACC: "DUACC",
  DSACC: "DSACC",
  DSEML: "DSEML",
  DCACC: "DCACC",
  DJACC: "DJACC",
  SLACC: "SLACC",
  SLVFY: "SLVFY",
  SLEML: "SLEML",
  SLSTS: "SLSTS",
  SUACC: "SUACC",
  SUVFY: "SUVFY",
  SUSRE: "SUSRE",
  SUSSE: "SUSSE",
  PYACC: "PYACC",
  PYVFY: "PYVFY",
  PYEDT: "PYEDT",
  PYSTS: "PYSTS",
  PTACC: "PTACC",
  PTDIS: "PTDIS",
  PTESC: "PTESC",
  PTREF: "PTREF",
  PTRES: "PTRES",
  PPACC: "PPACC",
  PPSAP: "PPSAP",
  PPSRE: "PPSRE",
  PDACC: "PDACC",
  PDESC: "PDESC",
  PDRFN: "PDRFN",
  PDRES: "PDRES",
  PRACC: "PRACC",
  PRDIS: "PRDIS",
  PRESC: "PRESC",
  PRREF: "PRREF",
  PRRES: "PRRES",
  PSACC: "PSACC",
  WLACC: "WLACC",
  WLVFY: "WLVFY",
  WUACC: "WUACC",
  WBACC: "WBACC",
  WPACC: "WPACC",
  WKACC: "WKACC",
  RTACC: "RTACC",
  RTVFY: "RTVFY",
  RTEDT: "RTEDT",
  RTFLT: "RTFLT",
};

export const QUESTIONNAIRE_ROUTE_PERMS = [
  PERM_CODE.EMACC,
  PERM_CODE.EMSQB,
  PERM_CODE.DMSQB,
];

export const routeMap = [
  { code: PERM_CODE.EMACC, path: "/enquiry-management" },
  { code: PERM_CODE.BUACC, path: "/business" },
  { code: PERM_CODE.IVACC, path: "/investor" },
  { code: PERM_CODE.ENACC, path: "/enterprise" },
  { code: PERM_CODE.CLACC, path: "/credit-limit" },
  { code: PERM_CODE.DLACC, path: "/deals-management" },
  { code: PERM_CODE.SLACC, path: "/settlements" },
  { code: PERM_CODE.PYACC, path: "/payments" },
  // { code: PERM_CODE.IUACC, path: "/invoice-upload" },
  { code: PERM_CODE.IUACC, path: "/deals-upload" },
  { code: PERM_CODE.WLACC, path: "/wallets" },
  { code: PERM_CODE.RTACC, path: "/reports" },
  { code: PERM_CODE.URACC, path: "/user-role-management/manage-users" },
];

export const ENQ_STATUS_PRIVILEGE_MAP = {
  [PERM_CODE.EQACC]: ["USM1000007"], // New
  [PERM_CODE.EYACC]: ["USM1000008"], // Review Pending
  [PERM_CODE.EAACC]: ["USM1000001"], // Active
  [PERM_CODE.ERACC]: ["USM1000006"], // Rejected
};

export const BUS_STATUS_PRIVILEGE_MAP = {
  [PERM_CODE.BLACC]: ["USM1000004"], // Delinquent
  [PERM_CODE.BAACC]: ["USM1000001"], // Active
  [PERM_CODE.BIACC]: ["USM1000002"], // Inactive
  [PERM_CODE.BDACC]: ["USM1000005"], // Deactivated
  [PERM_CODE.BBACC]: ["USM1000011"], // Blacklist
};

export const INV_STATUS_PRIVILEGE_MAP = {
  [PERM_CODE.INACC]: ["USM1000007"], // New
  [PERM_CODE.IAACC]: ["USM1000001"], // Active
  [PERM_CODE.IDACC]: ["USM1000005"], // Deactivated
  [PERM_CODE.IIACC]: ["USM1000002"], // Inactive
};

export const ENT_STATUS_PRIVILEGE_MAP = {
  [PERM_CODE.EPACC]: ["USM1000001"], // Pending
  [PERM_CODE.EVACC]: ["USM1000002"], // Active
  [PERM_CODE.EDACC]: ["USM1000004"], // Deactivated
  [PERM_CODE.EBACC]: ["USM1000006"], // Blacklist
};

export const CREDIT_STATUS_PRIVILEGE_MAP = {
  [PERM_CODE.CPACC]: ["USM1000001"], // Pending
  [PERM_CODE.CVACC]: ["USM1000002"], // Active
  [PERM_CODE.CDACC]: ["USM1000004"], // Deactivated
  [PERM_CODE.CRACC]: ["USM1000003"], // Rejected
};

export const DEAL_STATUS_PRIVILEGE_MAP = {
  [PERM_CODE.DPACC]: ["DSC1000001"], // Pending
  [PERM_CODE.DAACC]: ["DSC1000002"], // Approved
  [PERM_CODE.DEACC]: ["DSC1000003"], // Expired
  [PERM_CODE.DGACC]: ["DSC1000005"], // Funded
  [PERM_CODE.DDACC]: ["DSC1000006"], // Disbursed
  [PERM_CODE.DXACC]: ["DSC1000007"], // Cancelled
  [PERM_CODE.DRACC]: ["DSC1000009"], // Partially Settled
  [PERM_CODE.DSACC]: ["DSC1000010"], // Settled
  [PERM_CODE.DCACC]: ["DSC1000011"], // Closed
  [PERM_CODE.DJACC]: ["DSC1000012"], // Rejected
  [PERM_CODE.DUACC]: ["DSC1000017"], // Pending Disbursement
};

export const DEAL_JV_STATUS_PRIVILEGE_MAP = {
  [PERM_CODE.DPACC]: ["DSC1000001"], // Pending
  [PERM_CODE.DAACC]: ["DSC1000002"], // Approved
  [PERM_CODE.DJACC]: ["DSC1000012"], // Rejected
};

